import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FsComboOption } from '../../../common/fs-combobox/fs-combobox.component';

@Component({
  selector: 'app-session-step-details',
  templateUrl: './step-session-details.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class SessionStepDetailsComponent {
  @Input() form!: FormGroup;
  @Input() invitations: { id: string; name: string }[] = [];

  // Same calendar the Invitations wizard uses (ngx-bootstrap bsDatepicker), so the two date
  // fields look and behave identically. Expiry is a whole-day cutoff, so date-only matches.
  readonly bsConfig = { isAnimated: true, dateInputFormat: 'MM/DD/YYYY', showWeekNumbers: false };

  get invitationOptions(): FsComboOption[] { return this.invitations.map(i => ({ id: i.id, name: i.name })); }

  /** Earliest selectable expiry — no point expiring a session group in the past. */
  readonly minDate = new Date();

  showError(name: string): boolean {
    const c = this.form.get(name);
    return !!c && c.invalid && c.touched;
  }

  onPrimaryChange(id: string): void {
    this.form.get('primaryInvitationId')!.setValue(id);
    this.form.get('primaryInvitationId')!.markAsTouched();
  }
}
